import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router";
import Loader from "../../Loader/Loader";
import { category, editsubcategory } from "../../services/Mainservice";
import { Snackbar } from "../../utils/snackbar";
import { Plus } from "lucide-react";

const validate = (values, isInitialLoad) => {
  const errors = {};
  if (isInitialLoad) return errors;

  if (!values.name) {
    errors.name = "Required";
  }
  return errors;
};

const EditSubcategory = () => {
  const [load, setload] = useState(false);
  const [loading, setloading] = useState(true);
  const [success, setsuccess] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");
  const [cat, setcat] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [image, setImage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const items = location.state.item;
  console.log(location);

  useEffect(() => {
    getcategory();
  }, []);

  useEffect(() => {
    formik.setValues(
      {
        name: items.Name,
        type: items.category_id,
        preview: items.image,
      },
      false
    );
    formik.validateForm();
  }, [items]);

  const formik = useFormik({
    initialValues: {
      name: "",
      type: "",
      preview: "",
    },
    validate: (values) => validate(values, isInitialLoad),
    onSubmit: (values) => {
      handleAdd(values);
    },
  });
  const getcategory = async () => {
    try {
      const responce = await category();
      setcat(responce.data.data);
      setloading(false);
    } catch (error) {
      console.log(error);
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const handleAdd = async (values) => {
    setload(true);
    try {
      const response = await editsubcategory(items.id, values, image);
      setsuccess(response.data.message);
      setOpen2(true);
      setload(false);
      setTimeout(() => {
        navigate("/Subcategory_List");
      }, 1000);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleupload = (e) => {
    if (e.target && e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setImage(file);
      formik.setFieldValue("preview", URL.createObjectURL(e.target.files[0]));
    } else {
      console.log("No file selected");
    }
  };
  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Edit Subcategory</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Subcategory Name</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="name"
              type="text"
              minLength={1}
              maxLength={200}
              value={formik.values.name}
              className="Auth_input"
            />
            {formik.errors.name ? (
              <p className="invalid">{formik.errors.name} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Category Type</label>
            <br />
            <select
              onChange={formik.handleChange}
              name="type"
              className="Auth_input"
              value={formik.values.type}
              style={{ width: "94%" }}
            >
              {cat.map((i) => (
                <option value={i.id}>{i.Name}</option>
              ))}
            </select>
            {formik.errors.type ? (
              <p className="invalid">{formik.errors.type} </p>
            ) : null}
          </div>
          <div>
            <label htmlFor="img">
              <p className="Auth_label">Subcategory Image</p>

              {formik.values.preview ? (
                <img
                  src={formik.values.preview}
                  alt="image"
                  className="editprofile_image"
                />
              ) : (
                <>
                  <div className="addbox_image">
                    <Plus
                      style={{ color: "var(--white)", cursor: "pointer" }}
                    />
                    {/* <img src={addimg} alt="add image" /> */}
                  </div>
                </>
              )}
            </label>
            <input
              onChange={handleupload}
              id="img"
              name="img"
              type="file"
              className="Auth_input"
              style={{ display: "none" }}
            />
            {formik.errors.preview ? (
              <p className="invalid">{formik.errors.preview} </p>
            ) : null}
          </div>
          <div />

          <button className="term_button" type="Submit">
            {load ? "Updating..." : "Save"}
          </button>
        </form>
      </div>
      {loading && <Loader />}
      <Snackbar
        open={open}
        severity="error"
        onclose={() => setOpen(false)}
        message={err}
      />
      <Snackbar
        open={open2}
        severity="success"
        onclose={() => setOpen2(false)}
        message={success}
      />
    </>
  );
};
export default EditSubcategory;
